export class GameAvalancheReelEvents {
	public static readonly REMOVING_STARTED: string = 'GameAvalancheReelEvents::REMOVING_STARTED';

}



// WEBPACK FOOTER //
// ./src/avalanche/GameAvalancheReelEvents.ts